import {use} from 'i18next'
import {initReactI18next} from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import customPostProcess from './customPostProcess'
import de from './resources/de'
import en from './resources/en'

import type {InitOptions} from 'i18next'

export const defaultOptions: InitOptions = {
  lng: 'de',
  fallbackLng: 'de',
  defaultNS: 'common',
  supportedLngs: ['de', 'en'],
  postProcess: ['customContext'],
  resources: {
    de,
    en,
  },
}

export const initI18n = (options: InitOptions = {}) => use(initReactI18next)
  .use(LanguageDetector) //  https://www.npmjs.com/package/i18next-browser-languagedetector - detection order...
  .use(customPostProcess)
  .init({...defaultOptions, ...options})